export default {
  overview: 'Overview',
  specification: 'Specification',
  review: 'Review',
  compare: 'Compare',
  other_products: 'Other Products',
  price_info: 'Prices are a range of market averages, each shop may vary.',
  brand: 'Brand',
  color: 'Color',
  new: 'New',
};
